export default __webpack_public_path__ + "static/media/nodejs.3dc364b8.svg";